import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectCoverflow } from "swiper/modules";
import { Carousel } from "antd";
import styled from "styled-components";
import React from "react";
import "swiper/css";
import "swiper/css/effect-coverflow";

export default function CustomCarousel({ children, isMobile, more }) {
  const slidesPerView = 2;
  const slides = React.Children.toArray(children);
  let swiper = null;

  const handleSlideChange = () => {
    if (!swiper) return;

    if (swiper.activeIndex === slides.length - 1) {
      setTimeout(() => {
        swiper.slideTo(0);
      }, 2000);
    }
  };
  return (
    <div style={{ width: "auto", height: "auto" }}>
      <StyledSwiper
        more={more}
        isMobile={isMobile}
        modules={[Autoplay, EffectCoverflow]}
        effect="slide"
        grabCursor={true}
        initialSlide={0}
        centeredSlides={true}
        navigation={true}
        slidesPerView={slidesPerView}
        onSlideChange={handleSlideChange}
        speed={2000}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        onClick={(swiper, event) => {
          const clickedIndex = swiper.clickedIndex;
          if (clickedIndex !== swiper.activeIndex) {
            swiper.slideTo(clickedIndex);
          }
        }}
        loop={false}
        watchSlidesProgress={true}
      >
        {slides.map((child, index) => (
          <SwiperSlide key={`slide-${index}`}>{child}</SwiperSlide>
        ))}
      </StyledSwiper>
      <StyledCarousel
        isMobile={isMobile}
        autoplay
        dots={false}
        style={{ display: isMobile ? "block" : "none" }}
      >
        {children.map((child, index) => {
          if (!child) return null; // Skip if child is null or undefined
          return <div key={`mobile-slide-${index}`}>{child}</div>;
        })}
      </StyledCarousel>
    </div>
  );
}

const StyledSwiper = styled(Swiper)`
  height: ${(props) => (props.more ? "80vh" : "60vh")};
  width: 85%;
  display: ${(props) => (props.isMobile ? "none" : "block")};
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 1s ease;
    opacity: 1;
    position: relative;
    cursor: pointer;

    &:not(.swiper-slide-active) {
      transform: scale(0.8);

      .ant-image {
        position: relative;
        > img {
          position: relative;
          z-index: 1;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 2;
          pointer-events: none;
          border-radius: 10px;
        }
      }
      .image-container {
        position: relative;
        > img {
          position: relative;
          z-index: 1;
        }
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 2;
          pointer-events: none;
          border-radius: 10px;
        }
      }
      > * {
        pointer-events: none;
      }
    }
  }
`;
const StyledCarousel = styled(Carousel)`
  padding: 0 8vw;
  border-radius: 10px;

  .content-container {
    padding: 3vh 0;
  }
  .slick-slide {
    > div {
      line-height: 0;
    }
  }
  .carousel-item {
    line-height: normal;
  }
  .slick-track {
    display: flex;
    align-items: center;
  }
`;
